<template>
  <section :id="group.id">
    <!--class="listCourse"-->
    <div :class="group.isSelected ? 'onCourse' : 'listCourse'">
      <div class="hoverable" @click="setNewGroup">
        <div class="courseBox">
          <div class="leftSidePic">
            <img
              class="rightSidePic"
              width="58"
              height="58"
              :src="group.profileImage"
              alt=""
              id="courseImg"
            />
          </div>
          <div class="courseText">
            <p
              :class="
                group.hasUnreadPosts && !group.isSelected
                  ? 'courseTitleBold'
                  : 'courseTitle'
              "
            >
              {{ name }}
            </p>

            <div
              :class="
                group.hasUnreadPosts && !group.isSelected
                  ? 'withAndWithoutBold'
                  : 'withAndWithout'
              "
            >
              <p class="textPreviewWithoutTime">
                {{ group.recentUsername }} {{ group.recentContent }}
              </p>
              <p class="withTime">{{ group.recentTime }}</p>
            </div>
            <!--div v-if="group.hasUnreadPosts" class="withAndWithout">
              <b class="textPreviewWithoutTime" style="max-width"
                >{{ group.recentUsername }} {{ group.recentContent }}</b
              >
              <b class="withTime">{{ group.recentTime }}</b>
            </div-->
          </div>
        </div>
      </div>
      <span class="bottomline"></span>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState } from "vuex";
import db from "@/db";

export default {
  props: ["group"],
  data: () => ({
    name: "",
    id: "",
    groupTypes: [
      "General",
      "Course Related",
      "Club",
      "Intramural",
      "Study Group",
    ],
    selectedGroupType: "General",
  }),

  computed: {
    ...mapState("mainPage", ["onCalendar"]),
    ...mapState("user", ["user"]),
    ...mapState("messageBoard", ["groupId"]),
    ...mapState("groupInfo", ["defaultGroupImage"]),
  },

  mounted() {
    this.setName();
    this.id = this.group.id;
    //this.getRecentPost();
    //this.$store.commit("user/setUser", this.user);
  },

  methods: {
    ...mapActions("groupInfo", ["getGroupName"]),
    ...mapActions("groups", ["setGroupNotificationInfo"]),
    ...mapActions("messageBoard", ["setGroupId"]),
    ...mapActions("groupInfo", ["getGroupType"]),

    async setName() {
      this.name = await this.getGroupName(this.group);
    },

    getName() {
      return this.name.replace(/\s/g, "-");
    },

    async setNewGroup() {
      if (this.id !== this.groupId) {
        if (this.onCalendar) {
          this.$router.push({
            name: "Calendar",
            params: { name: this.name.replace(/\s/g, "-"), id: this.id },
          });
        } else {
          this.$router.push({
            name: "MessageBoard",
            params: {
              name: this.name.replace(/\s/g, "-"),
              id: this.id,
              type: this.group.type,
            },
          });
        }
      }
      this.$store.commit("messageBoard/setCurGroup", this.group);
      this.$store.commit("messageBoard/setGroupId", this.id);
      this.$store.commit("messageBoard/setGroupName", this.name);
      this.$store.commit("messageBoard/setGroupType", this.group.type);
      /*
      if (this.group.hasSeenLastPost < 8) {
        var userInfo = {
          name: this.user.firstName + " " + this.user.lastName,
          id: this.user.id,
          profileImage: this.user.profileImage,
        };
        this.group.hasSeenLastPost.push(userInfo);
        db.collection(type)
          .doc(this.id)
          .update({
            hasSeenLastPost: this.group.hasSeenLastPost,
          });
      }*/
    },

    async getRecentPost() {
      if (this.id) {
        await db
          .collection("posts")
          .where("chat_id", "==", this.id)
          .orderBy("created_at", "desc")
          .limit(1)
          .get()
          .then((snapshot) => {
            snapshot.forEach((doc) => {
              this.setGroupNotificationInfo({
                group: this.group,
                notification: doc.data(),
              });
            });
          });
      }
    },
  },
};
</script>
